import ReportTemplateInterpretationContext from "../../reports/InterpretationContext.js";

/**
 * This class holds the data used to interpret a forecast template
 * into a forecast. This includes the data used to interpret the
 * report templates of the forecast template.
 *
 * @param {ChartOfAccounts} chartOfAccounts - This chart of accounts
 *   is used by the report template interpreter
 * @param {KeyFigure[]} keyFigures - These key figures
 *   are used by the report template interpreter
 * @param {Period} period - This period (usually the current period)
 *   is used by the report template interpreter
 * @param {Company} company - This company is used by the report
 *   template interpreter
 */
export default class ForecastTemplateInterpretationContext {
	constructor({ chartOfAccounts, keyFigures, period, company }) {
		this._chartOfAccounts = chartOfAccounts;
		this._keyFigures = keyFigures;
		this._period = period;
		this._company = company;

		this._reportTemplateInterpretationContext =
			this._makeReportTemplateInterpretationContext();
	}

	getChartOfAccounts() {
		return this._chartOfAccounts;
	}

	getPeriod() {
		return this._period;
	}

	setPeriod(period) {
		this._period = period;
		this._reportTemplateInterpretationContext.setPeriod(period);
	}

	getCompany() {
		return this._company;
	}

	getReportTemplateInterpretationContext() {
		return this._reportTemplateInterpretationContext;
	}

	getAllAccounts() {
		return this._reportTemplateInterpretationContext.getAccounts();
	}

	getKeyFigures() {
		return this._keyFigures;
	}

	/**
	 * Creates a new interpretation context based on the
	 * properties of the receiver. Differences between the new
	 * context and the receiver can be expressed in `spec`.
	 */
	clone(spec = {}) {
		const newSpec = {
			chartOfAccounts: this._chartOfAccounts,
			company: this._company,
			period: this._period,
			...spec,
		};

		return new this.constructor(newSpec);
	}

	_makeReportTemplateInterpretationContext() {
		return new ReportTemplateInterpretationContext({
			chartOfAccounts: this._chartOfAccounts,
			period: this._period,
			company: this._company,
			keyFigures: this._keyFigures,
		});
	}
}
